import { render, staticRenderFns } from "./ClientTableForm.vue?vue&type=template&id=77e7bbbb&"
import script from "./ClientTableForm.vue?vue&type=script&lang=js&"
export * from "./ClientTableForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports